module.exports = __webpack_public_path__ + "static/media/hold.a60410df.svg";